export default {
  path: 'ingredient-unit',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'IngredientUnitList',
      component: () => import('@/views/settingSystem/pages/ingredient-unit/IngredientUnitList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'IngredientUnitCreate',
      component: () => import('@/views/settingSystem/pages/ingredient-unit/IngredientUnitCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'IngredientUnitEdit',
      component: () => import('@/views/settingSystem/pages/ingredient-unit/IngredientUnitEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
